import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const UploadRoundedIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#292D32"
      strokeWidth="1.5"
      {...props}
    >
      <path
        d="M9.32031 6.49994L11.8803 3.93994L14.4403 6.49994"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.8809 14.18V4.01001"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4 12C4 16.42 7 20 12 20C17 20 20 16.42 20 12"

        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}
